import { Box, Button, FormControl, MenuItem, Stack, TextField, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import * as Yup from 'yup';
import Header from '../../../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { useTheme } from '@emotion/react';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { addStocktransfer, editStocktransfer, getDetailsStocktransfer, getstockcategory, getstockProducts, getstockstore, getstockSubCategory, getStocktransfer, getstockWarehouseUser } from '../../../redux/slice/Stocktransfer.slice';
import { transferStore } from '../../../redux/slice/store.slice';

const validationSchemas =
  Yup.object({
    categoryId: Yup.string().required("Please enter user Category"),
    subCategoryId: Yup.string().required('Please enter user SubCategory'),
    productId: Yup.string().required("Please enter Product Name"),
    description: Yup.string().required("Please enter description"),
    unitofMeasurement: Yup.string().required("Please enter Unit of Measurment"),
    quantity: Yup.string().required("Please enter quantity"),
    debitWarehouseId: Yup.string().required("Please enter Debit Warehouse"),
    creditWarehouse: Yup.string().required("Please enter Credit Warehouse"),
    pupose: Yup.string().required("Please enter pupose"),
    modeofTransport: Yup.string().required("Please enter Mode of Transport"),

  });

// const userId = localStorage.getItem('id');

const initialValues = {
  categoryId: '',
  subCategoryId: '',
  productId: '',
  description: '',
  unitofMeasurement: '',
  quantity: '',
  debitWarehouseId: '',
  creditWarehouse: '',
  pupose: '',
  modeofTransport: '',

};

function Addstocltransfer() {

  const { state } = useLocation();
  const id = state?._id;
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const colors = tokens(theme.palette.mode);
  const product = useSelector((state) => state.stocktransfer.product);
  const category = useSelector((state) => state.stocktransfer.category);
  const subCategory = useSelector((state) => state.stocktransfer.subCategory);
  const warehouse = useSelector(state => state.stocktransfer.warehouse);
  const stocktransfer = useSelector((state) => state.stocktransfer.stocktransfer.stocktransfer);
  const storedata = useSelector((state) => state.stocktransfer.store);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isMobile = useMediaQuery('(max-width:500px)');

  // console.log("storedata",storedata);

  console.log("idididididid", id);
  

  const [stocktransferData, setStocktransferData] = useState(null);

  useEffect(() => {
    if (id && stocktransfer) {
      setStocktransferData(stocktransfer.find(st => st._id === id));
    }
  }, [id, stocktransfer])

  useEffect(() => {
    dispatch(getstockWarehouseUser());
    dispatch(getstockSubCategory());
    dispatch(getstockProducts());
    dispatch(getstockcategory());
    dispatch(getstockstore());
    dispatch(getStocktransfer());
    // dispatch(getDetailsStocktransfer(id));
  }, [dispatch, id])


  const { handleBlur, values, touched, errors, setFieldValue, setValues, validateForm, resetForm, handleSubmit: formikHandleSubmit } = useFormik({
    initialValues: { ...initialValues },
    validationSchema: validationSchemas,
    onSubmit: (values) => {
      const formData = {
        categoryId: values.categoryId,
        subCategoryId: values.subCategoryId,
        productId: values.productId,
        description: values.description,
        unitofMeasurement: values.unitofMeasurement,
        quantity: parseInt(values.quantity),
        debitWarehouseId: values.debitWarehouseId,
        creditWarehouseId: values.creditWarehouse,
        pupose: values.pupose,
        modeofTransport: values.modeofTransport,
      };

      if (id) {
        dispatch(editStocktransfer({ id: values._id, ...formData }));
      } else {
        dispatch(addStocktransfer(formData));
        dispatch(transferStore(formData));
      }
      navigate('/admin/stock-transfer');
      resetForm();
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    formikHandleSubmit();
  };

  const [filteredSubCategories, setFilteredSubCategories] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    if (values.categoryId) {
      const selectedSubCategories = subCategory.filter(
        (sub) => sub.categoryData?.[0]?._id === values.categoryId
      );
      setFilteredSubCategories(selectedSubCategories);
      setFieldValue('subCategoryId', '');
    } else {
      setFilteredSubCategories([]);
      setFieldValue('subCategoryId', '');
    }
  }, [values.categoryId, subCategory]);

  useEffect(() => {
    if (values.categoryId && values.subCategoryId) {
      const selectedProducts = product.filter(
        (prod) =>
          prod.mainCategoryData?.[0]?._id === values.categoryId &&
          prod.subCategoryData?.[0]?._id === values.subCategoryId
      );
      setFilteredProducts(selectedProducts);
    } else {
      setFilteredProducts([]);
    }
  }, [values.categoryId, values.subCategoryId, product]);

  console.log("filteredProducts", filteredProducts);

  useEffect(() => {
    setProductQuantity(0);
    setCreditProductQuantity(0);
    setFieldValue('debitWarehouseId', '');
    setFieldValue('creditWarehouse', '');
  }, [values?.productId])


  const [selectedWarehouseId, setSelectedWarehouseId] = useState('');
  const [productQuantity, setProductQuantity] = useState(null);

  const [selectedCreditWarehouseId, setSelectedCreditWarehouseId] = useState('');
  const [creditProductQuantity, setCreditProductQuantity] = useState(null);

  useEffect(() => {
    console.log("values.productId updated:", values.productId);
  }, [values.productId]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFieldValue(name, value);

    console.log("Field changed:", name, value);

    if (name === 'productId') {
      console.log("Product ID selected:", value);
      const selectedProduct = filteredProducts.find(product => product._id === value);
      if (selectedProduct) {
        console.log("Selected Product:", selectedProduct);
        setFieldValue('description', selectedProduct.Desacription);
        setFieldValue('unitofMeasurement', selectedProduct.unitOfMeasurement);
      }

      if (selectedWarehouseId) {
        console.log("Selected Warehouse ID:", selectedWarehouseId);
        const warehouseData = storedata.filter(store => store.warehouseId === selectedWarehouseId);
        if (warehouseData) {
          const productData = warehouseData.flatMap(v => {
            return v.multipleQty.filter(qty => qty.productName === selectedProduct?._id);
          });

          const avlQty = productData?.reduce((acc, v) => acc+v.recieveQty, 0)
          
          console.log("Product Data in Warehouse:", productData,avlQty);
          setProductQuantity(productData ? avlQty : 0);
        }
      }

      if (selectedCreditWarehouseId) {
        console.log("Selected Credit Warehouse ID:", selectedCreditWarehouseId);
        const creditWarehouseData = storedata.filter(store => store.warehouseId === selectedCreditWarehouseId);
        if (creditWarehouseData) {
          // const creditProductData = creditWarehouseData.multipleQty.find(qty => qty.productName === value);
          


          const productData = creditWarehouseData.flatMap(v => {
            return v.multipleQty.filter(qty => qty.productName === values.productId);
          });

          const avlQty = productData?.reduce((acc, v) => acc+v.recieveQty, 0)

          console.log("Credit Product Data:", productData, avlQty);

          setCreditProductQuantity(productData ? avlQty : 0);
        } else {
          setCreditProductQuantity(0);
        }
      }
    }

    if (name === 'debitWarehouseId') {
      console.log("Debit Warehouse ID selected:", value);
      setSelectedWarehouseId(value);
      const warehouseData = storedata.filter(store => store.warehouseId === value);
      if (warehouseData) {
        // const productData = warehouseData.multipleQty.find(qty => qty.productName === values.productId);
        console.log("Product Data in Debit Warehouse: 0", warehouseData);

        const productData = warehouseData?.flatMap(v => {
          return v.multipleQty.filter(qty => qty.productName === values.productId);
        });

        const avlQty = productData?.reduce((acc, v) => acc+v.recieveQty, 0)

        console.log("Product Data in Debit Warehouse: 1", productData, avlQty);

        
        setProductQuantity(productData ? avlQty : 0);
      } else {
        setProductQuantity(0);
      }
    }

    if (name === 'creditWarehouse') {
      console.log("Credit Warehouse ID selected:", value);
      setSelectedCreditWarehouseId(value);
      const warehouseData = storedata.filter(store => store.warehouseId === value);
      if (warehouseData) {
        // const productData = warehouseData.multipleQty.find(qty => qty.productName === values.productId);
        // console.log("Product Data in Credit Warehouse:", productData);

        const productData = warehouseData.flatMap(v => {
          return v.multipleQty.filter(qty => qty.productName === values.productId);
        });

        const avlQty = productData?.reduce((acc, v) => acc+v.recieveQty, 0)

        console.log("Product Data in Credit Warehouse:", productData, avlQty);


        setCreditProductQuantity(productData ? avlQty : 0);
      } else {
        setCreditProductQuantity(0);
      }
    }
  };

  // const handleChange = (event) => {
  //   const { name, value } = event.target;
  //   setFieldValue(name, value);

  //   console.log("values.productId", values.productId);


  //   if (name === 'productId') {
  //     const selectedProduct = filteredProducts.find(product => product._id === value);
  //     if (selectedProduct) {
  //       setFieldValue('description', selectedProduct.Desacription);
  //       setFieldValue('unitofMeasurement', selectedProduct.unitOfMeasurement);
  //     }

  //     if (selectedWarehouseId) {
  //       const warehouseData = storedata.filter(store => store.warehouseId === selectedWarehouseId);

  //       console.log("warehouseData", warehouseData, values.productId, selectedWarehouseId);

  //       if (warehouseData) {
  //         const productData = warehouseData.map(v => {
  //           return v.multipleQty.filter(qty => qty.productName === values.productId);
  //         });

  //         console.log("warehouseData productData", productData);

  //         // setProductQuantity(productData ? productData.recieveQty : 0);
  //       }
  //     }

  //     if (selectedCreditWarehouseId) {
  //       const creditWarehouseData = storedata.find(store => store.warehouseId === selectedCreditWarehouseId);
  //       console.log("warehouseData creditWarehouseData", creditWarehouseData);

  //       if (creditWarehouseData) {
  //         const creditProductData = creditWarehouseData.multipleQty.find(qty => qty.productName === value);

  //         console.log("warehouseData creditProductData", creditProductData);

  //         setCreditProductQuantity(creditProductData ? creditProductData.recieveQty : 0);
  //       } else {
  //         setCreditProductQuantity(0);
  //       }
  //     }
  //   }

  //   if (name === 'debitWarehouseId') {
  //     setSelectedWarehouseId(value);
  //     const warehouseData = storedata.find(store => store.warehouseId === value);
  //     if (warehouseData) {
  //       const productData = warehouseData.multipleQty.find(qty => qty.productName === values.productId);
  //       setProductQuantity(productData ? productData.recieveQty : 0);
  //     } else {
  //       setProductQuantity(0);
  //     }
  //   }

  //   if (name === 'creditWarehouse') {
  //     setSelectedCreditWarehouseId(value);
  //     const warehouseData = storedata.find(store => store.warehouseId === value);
  //     if (warehouseData) {
  //       const productData = warehouseData.multipleQty.find(qty => qty.productName === values.productId);
  //       setCreditProductQuantity(productData ? productData.recieveQty : 0);
  //     } else {
  //       setCreditProductQuantity(0);
  //     }
  //   }
  // };


  useEffect(() => {
    if (id, stocktransferData) {
      setValues(stocktransferData);
    }
  }, [id, dispatch, setValues, stocktransferData]);

  return (
    <Box m="2px">
      {id ? (
        <Header
          title="UPDATE STOCK TRANSFER"
          subtitle="Update Your Stock Transfer Here"
        />
      ) : (
        <Header
          title="ADD STOCK TRANSFER"
          subtitle="Manage Your Stock Transfer Here"
        />
      )}

      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
        }}
      >
        <TextField
          margin="dense"
          id="categoryId"
          name="categoryId"
          label="Catogory Name :"
          select
          fullWidth
          variant="filled"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.categoryId}
          error={touched.categoryId && Boolean(errors.categoryId)}
          helperText={touched.categoryId && errors.categoryId}
          InputLabelProps={{
            style: {
              color: theme.palette.text.primary
            }
          }}
        >
          {category.map((item) => (
            <MenuItem key={item._id} value={item._id}>{item.categoryName}</MenuItem>
          ))}
        </TextField>
        <TextField
          margin="dense"
          id="subCategoryId"
          name="subCategoryId"
          label="subCategory Name :"
          select
          fullWidth
          variant="filled"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.subCategoryId}
          error={touched.subCategoryId && Boolean(errors.subCategoryId)}
          helperText={touched.subCategoryId && errors.subCategoryId}
          InputLabelProps={{
            style: {
              color: theme.palette.text.primary
            }
          }}
        >
          {filteredSubCategories.map((item) => (
            <MenuItem key={item._id} value={item._id}>
              {item.subCategoryName}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          margin="dense"
          id="productId"
          name="productId"
          label="Product Name :"
          select
          fullWidth
          variant="filled"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.productId}
          error={touched.productId && Boolean(errors.productId)}
          helperText={touched.productId && errors.productId}
          InputLabelProps={{
            style: {
              color: theme.palette.text.primary
            }
          }}
        >
          {filteredProducts?.map((item) => (
            <MenuItem key={item._id} value={item._id}>
              {item.productName}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(3, minmax(0, 1fr))"
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 3" },
        }}
      >
        <FormControl variant="filled" sx={{ mt: 4, minWidth: 120 }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="description :"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.description}
            name="description"
            error={!!touched.description && !!errors.description}
            helperText={touched.description && errors.description}
            sx={{ gridColumn: "span 2" }}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          />
        </FormControl>
        <FormControl variant="filled" sx={{ mt: 4, minWidth: 120 }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Unit of Measurment :"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.unitofMeasurement}
            name="unitofMeasurement"
            error={!!touched.unitofMeasurement && !!errors.unitofMeasurement}
            helperText={touched.unitofMeasurement && errors.unitofMeasurement}
            sx={{ gridColumn: "span 2" }}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          />
        </FormControl>

        <FormControl variant="filled" sx={{ mt: 4, minWidth: 120 }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="quantity :"
            onBlur={handleBlur}
            onChange={(e) => {
              if (!values.debitWarehouseId) {
                alert('Please Select the Warehouse First');
                e.target.value = '';
                return;
              }
              const newValue = parseInt(e.target.value);
              if (newValue > productQuantity) {
                alert(`Quantity cannot exceed the available quantity of ${productQuantity}`);
                e.target.value = values.quantity;
              } else {
                handleChange(e);
              }
            }}
            value={values.quantity}
            name="quantity"
            error={!!touched.quantity && !!errors.quantity}
            helperText={touched.quantity && errors.quantity}
            sx={{ gridColumn: "span 2" }}
            InputProps={{
              inputProps: {
                min: 0,
              }
            }}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          />
        </FormControl>
        <Box>
          <TextField
            margin="dense"
            id="debitWarehouseId"
            name="debitWarehouseId"
            label="Debit Warehouse Type :"
            select
            fullWidth
            variant="filled"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.debitWarehouseId}
            error={touched.debitWarehouseId && Boolean(errors.debitWarehouseId)}
            helperText={touched.debitWarehouseId && errors.debitWarehouseId}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          >
            {warehouse.map((item) => (
              <MenuItem key={item._id} value={item._id}>{item.wareHouseName}</MenuItem>
            ))}
          </TextField>
          {productQuantity !== null && (
            <Box mt={2}>
              <p>Available Quantity: {productQuantity}</p>
            </Box>
          )}
        </Box>
        <Box>
          <TextField
            margin="dense"
            id="creditWarehouse"
            name="creditWarehouse"
            label="Credit Warehouse Type :"
            select
            fullWidth
            variant="filled"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.creditWarehouse}
            error={touched.creditWarehouse && Boolean(errors.creditWarehouse)}
            helperText={touched.creditWarehouse && errors.creditWarehouse}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          >
            {warehouse.map((item) => (
              <MenuItem key={item._id} value={item._id}>{item.wareHouseName}</MenuItem>
            ))}
          </TextField>
          {creditProductQuantity !== null && (
            <Box mt={2}>
              <p>Available Quantity: {creditProductQuantity}</p>
            </Box>
          )}
        </Box>
        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="pupose :"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.pupose}
            name="pupose"
            error={!!touched.pupose && !!errors.pupose}
            helperText={touched.pupose && errors.pupose}
            sx={{ gridColumn: "span 2" }}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          />
        </FormControl>
        <FormControl variant="filled" sx={{ mt: 1, minWidth: 120 }}>
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Mode of Transport :"
            onBlur={handleBlur}
            onChange={handleChange}
            value={values.modeofTransport}
            name="modeofTransport"
            error={!!touched.modeofTransport && !!errors.modeofTransport}
            helperText={touched.modeofTransport && errors.modeofTransport}
            sx={{ gridColumn: "span 2" }}
            InputLabelProps={{
              style: {
                color: theme.palette.text.primary
              }
            }}
          />
        </FormControl>
      </Box>
      <form onSubmit={handleSubmit}>
        <FormControl>
          <Stack direction="row" spacing={2} sx={{ m: 3, minWidth: 120 }}>
            <Button
              variant="contained"
              type="submit"
            >
              {id ? 'Update' : 'Submit'}
            </Button>
          </Stack>
        </FormControl>
      </form>
    </Box >
  )
}

export default Addstocltransfer;